import axios from 'axios';
import { API_BASE_URL, WHATSAPP_CONNECT_URL } from '../../utils/constants';
// import { getCookie } from '../../utils/persistor';

export const validateWebsite = async (url) => {
  const bodyFormData = new FormData();
  bodyFormData.append('site', url);
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/check-site',
    data: bodyFormData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.validation.valid;
};

export const handleAddNewContainer = async ({ url, email, title }) => {
  const bodyFormData = new FormData();
  bodyFormData.append('creator', title);
  bodyFormData.append('site', url);
  bodyFormData.append('email', email);
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/container/new',
    data: bodyFormData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const handleAddChannel = async ({ url, containerId, title }) => {
  const bodyFormData = new FormData();
  bodyFormData.append('containerId', containerId);
  bodyFormData.append('url', url);
  bodyFormData.append('signUp', true);
  bodyFormData.append('name', title);
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/addChannel',
    data: bodyFormData,
    withCredentials: true,
    headers: { 'Conent-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const handleFetchWebsites = async () => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/admin',
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleAddNewWebsite = async ({
  url,
  hasOperatorsByDefault,
  title,
}) => {
  const all_agents = hasOperatorsByDefault && 'on';
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/addSite',
    data: JSON.stringify({ url, all_agents, title }),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleToggleWebsiteStatus = async ({ id, isActive }) => {
  const bodyFormData = new FormData();
  bodyFormData.append('status', isActive ? 1 : 0);
  bodyFormData.append('channelId', id);
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/editChannelStatus',
    data: bodyFormData,
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data.ok;
};

export const handleAssignOperators = async (operatorIds, websiteId) => {
  const payload = {
    agentIds: operatorIds,
    channelId: websiteId,
    type: 3,
  };
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/agent/toggleAgent/ids',
    data: JSON.stringify(payload),
    withCredentials: true,
    headers: {
      'Content-Type': 'applicaion/json',
    },
  });
  return response.data;
};

export const handleFetchWhatsappBarcode = async (websiteId) => {
  let token = localStorage.getItem('token');
  const response = await axios({
    method: 'get',
    baseURL: WHATSAPP_CONNECT_URL,
    url: `/authenticated/${websiteId}`,
    withCredentials: true,
    headers: {
      'Content-Type': 'applicaion/json',
      Authorization: token,
    },
  });
  return response;
};

export const handleLogoutWhatsapp = async (websiteId) => {
  const response = await axios({
    method: 'delete',
    baseURL: WHATSAPP_CONNECT_URL,
    url: `/logout/${websiteId}`,
    withCredentials: true,
    headers: {
      'Content-Type': 'applicaion/json',
    },
  });
  return response.data;
};

export const handleSendContainersTeam = async (containersTeam) => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: `channel/assignAgent`,
    withCredentials: true,
    data: containersTeam,
    headers: {
      'Content-Type': 'applicaion/json',
    },
  });
  return response.data;
};

export const handleSendGroupMessage = async (messageInfo) => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: `channel/broadcast/message`,
    withCredentials: true,
    data: messageInfo,
    headers: {
      'Content-Type': 'applicaion/json',
    },
  });
  return response.data;
};

export const handleSendWhatsappGroupMessage = async (messageInfo) => {
  const response = await axios({
    method: 'post',
    baseURL: WHATSAPP_CONNECT_URL,
    url: 'api/broadcast/send/to/all',
    withCredentials: true,
    data: messageInfo,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleDeleteWebsite = async (channelID) => {
  const response = await axios.delete(
    `${API_BASE_URL}/channel/delete/${channelID}`,
    {
      withCredentials: true,
    }
  );

  return response.data;
};
